<template>
  <div class="page03">
    <div class="padding__">
      <div class="chapter">
        公司荣誉
      </div>
    </div>
    <div class="honor__list">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <div class="honer">
            <img src="../../../../assets/img/mobile/p-03-honor/2258@2x.png" />
          </div>
          <div class="honer">
            <img src="../../../../assets/img/mobile/p-03-honor/2259@2x.png" />
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honer">
            <img src="../../../../assets/img/mobile/p-03-honor/2260@2x.png" />
          </div>
          <div class="honer">
            <img src="../../../../assets/img/mobile/p-03-honor/2261@2x.png" />
          </div>
        </swiper-slide>
        <div id="swiper-pagination" slot="pagination"></div>
      </swiper>
      <!-- <div class="honer">
        <img src="../../../../assets/img/mobile/p-03-honor/2258@2x.png" />
      </div>
      <div class="honer">
        <img src="../../../../assets/img/mobile/p-03-honor/2259@2x.png" />
      </div>
      <div class="honer">
        <img src="../../../../assets/img/mobile/p-03-honor/2260@2x.png" />
      </div>
      <div class="honer">
        <img src="../../../../assets/img/mobile/p-03-honor/2261@2x.png" />
      </div> -->
    </div>
    <div class="padding__">
      <div class="chapter">
        合作伙伴
      </div>
      <div class="section" id="none_margin_bottom">
        <div class="title">
          阿里云联合解决方案认证伙伴、阿里云智能新零售R100伙伴
          <ul class="apt_pic">
            <li>
              <img
                src="../../../../assets/img/mobile/p-01-company/keyun02.png"
              />
            </li>
            <li>
              <img
                src="../../../../assets/img/mobile/p-01-company/keyun03.png"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      swiperOption: {
        pagination: {
          el: "#swiper-pagination"
          // dynamicBullets: true
          // type: "progressbar"
        }
      }
    };
  },
  mounted() {
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    this.$refs.mySwiper.swiper.slideTo(0, 1000, false);
  }
};
</script>
<style lang="scss" scoped>
.padding__ {
  padding: 0.2rem 0.4rem 0.1rem;
}
.page03 {
  .chapter {
    margin-top: 0.32rem;
    text-align: left;
    width: 2.12rem;
    height: 0.46rem;
    background: linear-gradient(
      266deg,
      rgba(62, 113, 255, 1) 0%,
      rgba(228, 236, 248, 0) 100%
    );
    border-radius: 0 0.24rem 0.24rem 0;
    font-size: 0.44rem;
    font-weight: bold;
    line-height: 0.1rem;
  }
  .honor__list {
    margin: 0.2rem 0 0.3rem;
    // overflow-x: auto;
    // overflow-y: hidden;
    // white-space: nowrap;
    .honer {
      display: inline-block;
      width: 3.58rem;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  // .chapter_why {
  //   width: 3rem;
  // }
  .section {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0rem 0rem 0rem rgba(41, 43, 58, 0.05);
    opacity: 1;
    border-radius: 0.3rem;
    margin-top: 0.24rem;
    padding: 0.4rem 0.4rem 0.24rem;
    text-align: left;
    // .name {
    //   font-size: 0.28rem;
    //   font-weight: bold;
    //   line-height: 0.4rem;
    //   color: rgba(41, 43, 58, 1);
    //   display: flex;
    //   justify-content: flex-start;
    //   align-items: center;
    //   padding-bottom: 0.48rem;
    //   .point {
    //     display: inline-block;
    //     width: 0.42rem;
    //     height: 0.42rem;
    //     margin-right: 0.12rem;
    //     background-size: auto 100%;
    //     background-repeat: no-repeat;
    //     background-position: center center;
    //   }
    //   .point01 {
    //     background-image: url("../../../../assets/img/mobile/p-03-honor/575@2x.png");
    //   }
    //   .point02 {
    //     background-image: url("../../../../assets/img/mobile/p-03-honor/578@2x.png");
    //   }
    //   .point03 {
    //     background-image: url("../../../../assets/img/mobile/p-03-honor/579@2x.png");
    //   }
    // }
    .title {
      font-size: 0.32rem;
      font-weight: bold;
      line-height: 0.44rem;
      color: rgba(41, 43, 58, 1);
    }
    .apt_pic {
      margin-top: 0.24rem;
      display: flex;
      li {
        width: 2.8rem;
        height: 3.88rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .apt_pic li:nth-child(2) {
      margin-left: 0.3rem;
    }
  }
}
</style>
